<template>
  <v-card class="maxh-100 mx-0 d-flex flex-column white" style="overflow-y: hidden!important;min-height: 0;;">
<div class="search-results-header">
<div class=" pa-4 elevation-2 transparent d-flex align-center">

  <v-text-field
    style="flex: 1 1 auto;"
    class="mr-2"
    ref="searchOverlayTextField"
    v-model="localSearchtext"
    @keyup="$emit('update:searchtext', $event, localSearchtext)"
    solo
    outlined
    prepend-inner-icon="mdi-magnify"
    hide-details
  />

  <div style="flex: 0 0 auto;">
    <v-btn icon @click="$emit('close')">
      <v-icon>mdi-close</v-icon>
    </v-btn>
  </div>

</div>

    <!-- SUBHEADER (Pagination + Info) -->
    <div v-if="$vuetify.breakpoint.smAndUp" class="mx-2" >
      <v-subheader style="padding: 0px;">
        <v-list-item-action class="ml-n2">
          <v-btn icon @click="$emit('previous')" :disabled="searchPack <= 0">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
        </v-list-item-action>

        <v-list-item-content class="text-center">
          <v-list-item-title class="grey--text">
            {{ getSearchRangeText }}
          </v-list-item-title>
          <v-list-item-subtitle>
            {{ getResultsForText }}
          </v-list-item-subtitle>
        </v-list-item-content>

        <v-list-item-action>
          <v-btn
            icon
            @click="$emit('next')"
            :disabled="searchPack + results.length === totalres"
          >
            <v-icon>mdi-arrow-right</v-icon>
          </v-btn>
        </v-list-item-action>
      </v-subheader>
    </div>
</div>
    <div class="flex-grow-1 overflow-y-auto">

    <!-- RESULTS -->
    <div v-if="$vuetify.breakpoint.smAndUp" fluid >
      <v-row
        v-for="(item, index) in results"
        :key="index"
        no-gutters
      >
        <v-col

        >
          <result-card :item="item"/>
        </v-col>
      </v-row>

    </div>
    <lazyTileGrid v-else-if="results.length > 0" @loadMore="getNextResults"  :items="getItems(results)" :itemsCount="totalres" ></lazyTileGrid>

    </div>

  </v-card>
</template>

<script>
import { get } from 'jquery';
import ResultCard from './ResultCard'
import lazyTileGrid from './lazyTileGrid'
import {filterRelatedAnnotationsByHighlight} from '@/utils/helpers'

export default {
  name: 'SearchOverlay',
  components: {
    ResultCard,
    lazyTileGrid
  },
  props: {
    results: Array,
    loading: Boolean,
    searchtext: String,
    searchPack: Number,
    totalres: Number
  },
  data () {
    return {
      localSearchtext: this.searchtext
    }
  },
  methods: {
    getItems(results) {
      var items = []
      for (const result of results) {
        var item = result._source
        const annotations = filterRelatedAnnotationsByHighlight(result, this.$store.getters.getAnnotations)
        item.highlightedAnnotations = annotations
        items.push(item)
      }
      return items

    },
    close () {
      this.$emit('close')
    },
    getNextResults() {
      this.$log.debug("getNextResults truggered")
      this.$emit('addnext')
    }
  },
computed: {
  getResultsForText() {
    if (!this.searchtext) {
      return "Please enter a search term."
    }
    return 'Results for: ' + this.searchtext
  },
  getSearchRangeText() {
    if (this.totalres > 0) {
      return `Results ${this.searchPack + 1} - ${this.searchPack + this.results.length} of ${this.totalres}`
    }
    return ""
  },
},
mounted() {
  this.$log.debug("SearchOverlay mounted");
  this.$nextTick(() => {
    if (this.$refs.searchOverlayTextField) {
      this.$refs.searchOverlayTextField.focus()
      this.$log.debug("focus on input")
    }
  })

},
watch: {
  results() {
    this.$emit('update:results', this.results)
  },
  localSearchtext() {
    this.$log.debug("localSearchtext:", this.localSearchtext)
  }
}
}
</script>
<style scoped>
  .search-results-header {
  position: sticky;
  top: 0;
  z-index: 20;
  background: white;   /* WICHTIG */
}
</style>